import HeroSection from "./components/HeroSection";
import FeatureSection from "./components/FeatureSection";
import AboutSection from "./components/AboutSection";
import UsedByHospitals from "./components/UseByHospitals";
import FooterSection from "./components/FooterSection";
import ContactSection from "./components/ContactSection";

const HomePage = () => (
    <>
        <HeroSection/>
        <AboutSection/>
        <FeatureSection/>
        <UsedByHospitals/>
        <ContactSection/>
        <div className="relative">
            <div className="absolute inset-0 flex items-center" aria-hidden="true">
                <div className="w-full border-t border-gray-300"/>
            </div>
        </div>
        <FooterSection/>
    </>

);
export default HomePage;
